import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "sonner";
import { trackPageView } from "@/lib/pixel";

import Landing from "@/pages/Landing";
import { LoginPage, RegisterPage } from "@/pages/Auth";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import Dashboard from "@/pages/Dashboard";
import { PlanoAulaPage, AtividadePage, AvaliacaoPage, AdaptarPage } from "@/pages/Tools";
import { MateriaisPage, MaterialDetailPage } from "@/pages/Materiais";
import { PerfilPage, AssinaturaPage } from "@/pages/AccountPages";
import AdminPanel from "@/pages/AdminPanel";
import { PaymentSuccessPage, PaymentCancelPage, PaymentExpiredPage } from "@/pages/PaymentPages";
import AuthCallback from "@/pages/AuthCallback";
import { ForgotPasswordPage, ResetPasswordPage } from "@/pages/PasswordPages";
import SupportPage from "@/pages/SupportPage";
import { TermsPage, PrivacyPage } from "@/pages/LegalPages";

function RouteTracker() {
  const { pathname } = useLocation();
  useEffect(() => { trackPageView(); }, [pathname]);
  return null;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <RouteTracker />
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/payment/success" element={<PaymentSuccessPage />} />
          <Route path="/payment/cancel" element={<PaymentCancelPage />} />
          <Route path="/payment/expired" element={<PaymentExpiredPage />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />

          <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/plano-aula" element={<PlanoAulaPage />} />
            <Route path="/atividade" element={<AtividadePage />} />
            <Route path="/avaliacao" element={<AvaliacaoPage />} />
            <Route path="/adaptar" element={<AdaptarPage />} />
            <Route path="/materiais" element={<MateriaisPage />} />
            <Route path="/materiais/:id" element={<MaterialDetailPage />} />
            <Route path="/conta" element={<PerfilPage />} />
            <Route path="/assinatura" element={<AssinaturaPage />} />
            <Route path="/suporte" element={<SupportPage />} />
          </Route>

          <Route path="/termos" element={<TermsPage />} />
          <Route path="/privacidade" element={<PrivacyPage />} />

          <Route path="/admin" element={
            <ProtectedRoute adminOnly><AdminPanel /></ProtectedRoute>
          } />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
